var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSfFlameIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 58.387,
    height: 76.536,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(115.897 19.792 358.572) scale(45.82157)",
    spreadMethod: "pad",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#b61f24"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#b61f24"
    },
    offset: 0.028
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#b61f24"
    },
    offset: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#cb2027"
    },
    offset: 0.394
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#cb2027"
    },
    offset: 0.428
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#991b1e"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(23.23568) rotate(2.621 -485.82 305.814)",
    spreadMethod: "pad",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#0c4b80"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#0c4b80"
    },
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3b9ed8"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(27.5871) rotate(49.139 -13.791 22.383)",
    spreadMethod: "pad",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#1a6935"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#1a6935"
    },
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#0cae4b"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-41.556) rotate(-64.103 -13.837 .632)",
    spreadMethod: "pad",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#ec4852"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#ea7b23"
    },
    offset: 0.012
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#ea7b23"
    },
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f9a11b"
    },
    offset: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f9c80f"
    },
    offset: 0.787
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f9c80f"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(316.625 524.625) scale(19.29325)",
    spreadMethod: "pad",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#12284d"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#12284d"
    },
    offset: 0.028
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#12284d"
    },
    offset: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3b9ed8"
    },
    offset: 0.394
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3b9ed8"
    },
    offset: 0.428
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#12284d"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(49.139 -390.644 633.156) scale(20.28212)",
    spreadMethod: "pad",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#193018"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#1a6935"
    },
    offset: 0.279
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#1a6935"
    },
    offset: 0.294
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#0cae4b"
    },
    offset: 0.586
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#0cae4b"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(2.621 -11613.004 7252.66) scale(13.39134)",
    spreadMethod: "pad",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3b9ed8"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3b9ed8"
    },
    offset: 0.073
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3b9ed8"
    },
    offset: 0.482
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3b9ed8"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(13.31462 0 0 -13.31462 346.14 527.436)",
    spreadMethod: "pad",
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f9c80f"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f9c80f"
    },
    offset: 0.213
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f9a11b"
    },
    offset: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#ea7b23"
    },
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#ea7b23"
    },
    offset: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#ec4852"
    },
    offset: 1
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M335.959 551.078c-.124-1.783.258-3.018.974-4.656.719-1.648 1.788-3.212 2.322-4.923.425-1.361.614-2.841.641-4.265.054-2.946-.702-6.032-2.665-8.3-2.721-3.144-6.935-4.469-10.386-6.604-6.296-3.893-6.74-12.908-2.777-18.641.326-.471.681-.921 1.063-1.347 1.463-1.597 3.663-2.804 5.848-3.232 1.077-.227 1.16-.225 1.437-.267 3.031-.469 5.588-.316 8.778.544-2.103-.383-4.193-.197-6.069.857-2.62 1.473-3.446 5.232-2.834 7.976.496 2.228 1.965 4.266 3.947 5.41 2.349 1.356 5.116 1.68 7.558 2.823 6.556 3.067 9.462 10.595 7.829 17.445-1.069 4.49-3.497 9.353-7.227 12.185-1.419 1.076-2.909 2.04-4.043 3.444-.75.929-1.393 1.96-1.776 3.096-.374 1.106-.334 3.361-.334 3.361-1.185-.899-2.187-3.472-2.286-4.906",
    style: {
      fill: "url(#a)",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -417.885 741.312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.265 546.745v.003zm-.219-5.375c-1.485-4.276-4.797-7.361-9.572-7.194-2.938.103.193 4.134.371 4.318-1.485-.937-3.591-2.918-4.871-4.556-5.074-6.485-6.036-15.773-2.271-23.148.969-1.898 2.18-3.712 3.656-5.271.753-.794 1.477-1.564 2.409-2.228.279-.199 1.656-1.195 2-1.415-1.038.794-2.626 2.549-3.259 3.703-1.748 3.187-2.393 7.055-1.874 10.646.143.987.413 1.956.815 2.87 3.188 7.246 13.417 7.624 15.801 15.466 1.088 3.582.565 7.689-1.668 10.736a9.312 9.312 0 0 1-.885 1.05c-.044.044-.428.335-.433.398.012-1.232.39-3.623-.219-5.375",
    style: {
      fill: "url(#b)",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -417.885 741.312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.071 517.95c-2.542-3.627-4.31-5.112-10.599-6.554-2.258-.517-5.366-1.763-5.513-5.645-.126-3.319 2.55-5.613 5.191-5.536.283.009 2.411-.021 7.557 3.225 7.253 4.575 12.517 18.289 4.406 29.847 2.642-4.894 1.679-11.454-1.042-15.337",
    style: {
      fill: "url(#c)",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -417.885 741.312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.793 524.593c-21.005-1.76-14.357-17.836-13.979-18.671.188-.533 3.783-10.107 18.38-6.535-12.379-1.904-15.203 9.141-12.409 13.274 2.227 3.295 4.991 4.786 13.435 7.061 9.433 2.543 9.781 11.895 9.405 14.176-.48 2.925-3.411 9.762-8.122 12.85 0 0 17.378-20.136-6.71-22.155",
    style: {
      fill: "url(#d)",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -417.885 741.312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.906 523.655c-10.303-10.714 1.396-20.979.624-19.808-2.717 4.133-7.475 15.43 5.479 22.201 15.344 8.021 6.442 20.176 5.256 20.7 8.524-15.294-6.384-17.92-11.359-23.093",
    style: {
      fill: "url(#e)",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -417.885 741.312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.206 520.006c-2.856-6.065-7.307-7.31-7.307-7.31 1.363.108 2.674.687 3.889 1.332.848.451 4.708 3.591 5.605 7.687.444 2.032.532 4.144.125 6.19a13.191 13.191 0 0 1-1.464 3.954c-.273.477-.688.9-.941 1.376 3.489-6.587.093-13.229.093-13.229",
    style: {
      fill: "url(#f)",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -417.885 741.312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.701 534.996c-9.315-3.218-3.856 3.498-3.856 3.498s-8.197-7.453 1.615-5.207c10.632 2.433 7.805 13.461 7.805 13.461.451-9.477-5.564-11.752-5.564-11.752",
    style: {
      fill: "url(#g)",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -417.885 741.312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.932 546.159c.205-.27.505-.668.873-1.183a34.85 34.85 0 0 0 2.738-4.468c.488-.966.96-2.045 1.328-3.228.185-.591.332-1.21.444-1.849.106-.64.161-1.302.149-1.973a7.351 7.351 0 0 0-1.161-3.907l-.304-.431c-.108-.139-.226-.271-.338-.408l-.085-.102-.022-.025-.021-.02-.047-.048-.19-.192-.191-.192-.201-.173a8.647 8.647 0 0 0-1.769-1.193 13.002 13.002 0 0 0-1.988-.813 19.954 19.954 0 0 0-2.074-.53c-1.392-.286-2.784-.464-4.129-.645-1.347-.175-2.65-.356-3.875-.596-1.225-.235-2.372-.532-3.397-.906a13.132 13.132 0 0 1-2.671-1.3 26.876 26.876 0 0 1-1.858-1.335c-.129-.093-.239-.194-.347-.285a76.73 76.73 0 0 0-.301-.26c-.089-.086-.169-.167-.244-.241l-.106-.104c-.033-.035-.06-.071-.087-.104-.054-.065-.105-.12-.142-.175l-.085-.139c-.019-.039-.027-.072-.036-.092-.006-.022-.004-.034-.005-.034.001 0 0 .012.006.034.009.02.019.053.037.091.025.036.054.082.09.137.037.051.09.105.145.17.027.032.055.067.089.1l.109.104.247.233.306.251c.109.089.221.188.351.28.503.38 1.135.826 1.877 1.297.747.464 1.647.892 2.668 1.251 1.021.36 2.163.643 3.386.863 1.221.224 2.522.388 3.868.563 1.347.176 2.743.348 4.146.632a20.83 20.83 0 0 1 2.098.527c.693.221 1.375.488 2.027.823a8.793 8.793 0 0 1 1.813 1.234l.208.181.19.192.19.191.048.049c.009.01.013.012.026.027l.022.027.087.103c.116.141.237.277.347.422.105.148.208.297.312.446a7.562 7.562 0 0 1 1.18 4.017c.009.686-.046 1.361-.164 2.009-.12.647-.276 1.273-.469 1.868a21.224 21.224 0 0 1-1.373 3.238 29.168 29.168 0 0 1-1.505 2.558 38.94 38.94 0 0 1-1.31 1.876c-.377.511-.69.897-.901 1.164l-.328.404.319-.411",
    style: {
      fill: "url(#h)",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 -417.885 741.312)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSfFlameIcon);
export default __webpack_public_path__ + "static/media/SF_Flame_Icon.458222566ffc3282348c4bc48695b3e7.svg";
export { ForwardRef as ReactComponent };